import QualityMentoringFormQuestion from './QualityMentoringFormQuestion';
import LocalizedString from './LocalizedString';

export default class QuestionGroup {
  public id: number;

  public title: LocalizedString;

  public questions: QualityMentoringFormQuestion[] = [];

  public static createFromRow(row: any): QuestionGroup {
    const group = new QuestionGroup();
    group.id = row.id;
    group.title = new LocalizedString(row.title);
    return group;
  }
}
